export default __webpack_public_path__ + "static/media/am2.57a1e312.jpg";